import React, { useState } from 'react';
import { format, parse, isValid } from 'date-fns';
import { de } from 'date-fns/locale';
import { Calendar as CalendarIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { Label } from '@/components/ui/label';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

/**
 * Deutsche Datums-Picker Komponente
 * Verwendet dd.MM.yyyy Format (deutsches Datumsformat)
 */
const DatePickerField = ({ value, onChange, disabled = false, placeholder = "TT.MM.JJJJ", label }) => {
  const [open, setOpen] = useState(false);

  // Parse German date string to Date object
  const parseGermanDate = (dateStr) => {
    if (!dateStr) return null;
    const parsed = parse(dateStr, "dd.MM.yyyy", new Date());
    return isValid(parsed) ? parsed : null;
  };

  // Format Date object to German date string
  const formatGermanDate = (date) => {
    if (!date) return "";
    return format(date, "dd.MM.yyyy");
  };

  const selectedDate = parseGermanDate(value);

  const handleSelect = (date) => {
    if (date) {
      onChange(formatGermanDate(date));
    }
    setOpen(false);
  };

  return (
    <div className="space-y-1">
      {label && <Label className="text-xs">{label}</Label>}
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            disabled={disabled}
            className={`w-full justify-start text-left font-normal h-9 ${!value ? "text-muted-foreground" : ""}`}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {value || placeholder}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="single"
            selected={selectedDate}
            onSelect={handleSelect}
            locale={de}
            initialFocus
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default DatePickerField;
